<script lang="ts">
  import type { BaseNodeData } from "@shared/common/node/type";
  import { getStore } from "../../context";
  import AutomatedProductList from "./automated-product-list.svelte";
  import CardWrapper from "./card-wrapper.svelte";
  import Document from "./document.svelte";
  import FormChoice from "./form-choice.svelte";
  import FormDivider from "./form-divider.svelte";
  import FormDropdown from "./form-dropdown.svelte";
  import FormFileUploader from "./form-file-uploader.svelte";
  import FormHiddenField from "./form-hidden-field.svelte";
  import FormImageChoice from "./form-image-choice.svelte";
  import FormImageVideo from "./form-image-video.svelte";
  import FormInput from "./form-input.svelte";
  import FormNPS from "./form-nps.svelte";
  import FormPrivacyPolicy from "./form-privacy-policy.svelte";
  import FormRatingScale from "./form-rating-scale.svelte";
  import FormSeanEllis from "./form-sean-ellis.svelte";
  import FormText from "./form-text.svelte";
  import FormTextarea from "./form-textarea.svelte";
  import Form from "./form.svelte";
  import Frame from "./frame.svelte";
  import Image from "./image.svelte";
  import InstagramGallery from "./instagram-gallery.svelte";
  import ProductGridList from "./product-grid-list.svelte";
  import ProductXScrollList from "./product-x-scroll-list.svelte";
  import SectionGroup from "./section-group.svelte";
  import SingleProduct from "./single-product.svelte";
  import Slot from "./slot.svelte";
  import SocialProof from "./social-proof.svelte";
  import SwiperButtonGroup from "./swiper-button-group.svelte";
  import SwiperContainer from "./swiper-container.svelte";
  import SwiperPagination from "./swiper-pagination.svelte";
  import Text from "./text.svelte";
  import Timer from "./timer.svelte";
  import Video from "./video.svelte";

  const { captureMode } = getStore();

  export let wrapperType: "iframe" | "embedded";
  export let node: BaseNodeData;
  export let depth: number;
</script>

{#if node.type === "DOCUMENT"}
  <Document {node} {wrapperType}>
    {#each node.children || [] as child}
      <svelte:self node={child} depth={depth + 1} {wrapperType} />
    {/each}
  </Document>
{:else if node.type === "FRAME"}
  <Frame {node} hideShadow={depth === 2 && $captureMode}>
    {#each node.children || [] as child}
      <svelte:self node={child} depth={depth + 1} {wrapperType} />
    {/each}
  </Frame>
{:else if node.type === "SECTION_GROUP"}
  <SectionGroup {node} hideShadow={depth === 2 && $captureMode}>
    {#each node.children || [] as child}
      <svelte:self node={child} depth={depth + 1} {wrapperType} />
    {/each}
  </SectionGroup>
{:else if node.type === "TEXT"}
  <Text {node} />
{:else if node.type === "IMAGE"}
  <Image {node} />
{:else if node.type === "INSTAGRAM_GALLERY"}
  <InstagramGallery {node} />
{:else if node.type === "SLOT"}
  <Slot {node} {depth} {wrapperType} />
{:else if node.type === "SINGLE_PRODUCT"}
  <SingleProduct {depth} {wrapperType} {node} />
{:else if node.type === "PRODUCT_X_SCROLL_LIST"}
  <ProductXScrollList {node} />
{:else if node.type === "AUTOMATED_PRODUCT_LIST"}
  <AutomatedProductList {node} />
{:else if node.type === "PRODUCT_GRID_LIST"}
  <ProductGridList {node} />
{:else if node.type === "SWIPER_CONTAINER"}
  <SwiperContainer {node} {depth} {wrapperType} />
{:else if node.type === "SWIPER_PAGINATION"}
  <SwiperPagination {node} />
{:else if node.type === "SWIPER_BUTTON_GROUP"}
  <SwiperButtonGroup {node} />
{:else if node.type === "FORM"}
  <Form {node}>
    {#each node.children || [] as child}
      <svelte:self node={child} depth={depth + 1} {wrapperType} />
    {/each}
  </Form>
{:else if node.type === "FORM_INPUT"}
  <FormInput {node} />
{:else if node.type === "FORM_CHOICE"}
  <FormChoice {node} />
{:else if node.type === "FORM_SEAN_ELLIS"}
  <FormSeanEllis {node} />
{:else if node.type === "FORM_PRIVACY_POLICY"}
  <FormPrivacyPolicy {node} />
{:else if node.type === "FORM_DIVIDER"}
  <FormDivider {node} />
{:else if node.type === "FORM_DROPDOWN"}
  <FormDropdown {node} />
{:else if node.type === "FORM_IMAGE_CHOICE"}
  <FormImageChoice {node} />
{:else if node.type === "FORM_TEXT"}
  <FormText {node} />
{:else if node.type === "FORM_RATING_SCALE"}
  <FormRatingScale {node} />
{:else if node.type === "FORM_TEXTAREA"}
  <FormTextarea {node} />
{:else if node.type === "FORM_IMAGE_VIDEO"}
  <FormImageVideo {node} />
{:else if node.type === "FORM_HIDDEN_FIELD"}
  <FormHiddenField {node} />
{:else if node.type === "FORM_NPS"}
  <FormNPS {node} />
{:else if node.type === "FORM_FILE_UPLOADER"}
  <FormFileUploader {node} />
{:else if node.type === "VIDEO"}
  <Video {node} />
{:else if node.type === "TIMER"}
  <Timer {node} />
{:else if node.type === "CARD_WRAPPER"}
  <CardWrapper {node} />
{:else if node.type === "SOCIAL_PROOF"}
  <SocialProof {node} />
{/if}
